import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Accordion, Form, Image, Modal } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import { ProfileUrl } from "../commons/IPAddress";
import { IPUrl } from "../commons/IPAddress";
import logo1 from '../assets/img/alert8.png'
import OrderForm from "./OrderForm";
import BigLoaders from "../components/BigLoaders";
import Ripples from 'react-ripples'

function Orders() {
  const [orderId, setOrderId] = useState(0);
  const [status, setStatus] = useState(true);
  const [show, setShow] = useState(false);
  const [snip, setSnip] = useState(false);
  const [order, setOrder] = useState();
  const [radioText, setRadioText] = useState("");
  const [radioItem, setRadioItem] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [Stchange, setstchange] = useState(false);
  const [orderTypeId, setorderTypeId] = useState(2);
  const [seenFile, setSeenFile] = useState([]);
  const [listOredr, setListOredr] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()


  const handleClose = () => setShow(false);
  const handleShow = (orderId) => {
    setShow(true);
    setOrder(orderId);
  }

  useEffect(() => {
    console.log(orderTypeId)
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      setSnip(true)
      axios
        .post(apiUrl + "Get_DriverOrders", {
          code: orderTypeId,
          TokenId: userToken,
          Areaid: 0,
        })

        .then((res) => {
          setSnip(false)
          if (res.data.result === "true") {
            console.log(res.data.data)
            setSeenFile(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [orderTypeId, Stchange]);


  const detailHandler = (index, val) => {
    console.log(val)
    const axios = require("axios");
    axios
      .post(apiUrl + "Get_DetailsOrders", {
        code: val,
        TokenId: userToken,
        Code_Meli: "fddf"
      })

      .then((res) => {
        console.log("result" + res.data.result)
        if (res.data.result === "true") {

          console.log(res.data.data)
          setListOredr(res.data.data);
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const deleteHandler = (val) => {
    if (radioItem === 0) {
      toast.error("لطفا یکی از گزینه ها را انتخاب نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "DeleteOrders", {
          reasonI_Id: radioItem,
          reason: radioText,
          code: val,
          TokenId: userToken,
          Code_Meli: "hjjhgh"
        })
  
        .then((res) => {
          setShow(false)
          if (res.data.result === "true") {
            if (Stchange) {
              setstchange(false)
            } else {
              setstchange(true)
            }
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }

  const toggleHandler = (id) => {
    if (isOpen) {
      setIsOpen(false);
      setOrderId(0);
      setStatus(true)
    }
    else {
      setIsOpen(true);
      setOrderId(id);
      setStatus(true)
    }
  };

  const RadioHandlerChange = (val, txt) => {
    setRadioItem(val);
    setRadioText(txt);
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <Row className="justify-content-center gx-1 gx-md-5 gy-3">
              <Col xs={6}>
                <div className="d-flex rgc-title">
                  <div className="rgc-title-point"></div>
                  <h4>تمامی <span>سفارشات</span></h4>
                </div>
              </Col>

              <Col xs={6} md={3} className="text-start me-auto pt-2">
                <Form.Select
                  aria-label="Default select example"
                  className="rgc-select"
                  value={orderTypeId}
                  onChange={(e) => setorderTypeId(e.target.value)}
                >
                  {/* <option value="0">انتخاب همه</option> */}
                  {/* <option value="1">در انتظار  پذیرش</option>*/}
                  <option value="2"> پذیرش شده</option>
                  <option value="3">اتمام یافته</option>
                  <option value="4">لغو شده</option>
                  <option value="5">دارای اعتراض</option>
                </Form.Select>
              </Col>

              <Col xs={12} className="text-center">
                <BigLoaders loads={snip} />
                <Accordion defaultActiveKey="0" flush >
                  {seenFile.length === 0 ?
                    <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                      <span>سفارش موجود نیست</span>
                    </Col>
                    :
                    seenFile.map((data, index) => {
                      return (
                        <Accordion.Item className="rgc-driver-card"
                          key={index}
                          eventKey={index} onClick={() => detailHandler(index, data.Order_Id)}>
                          <Accordion.Header>
                            <Row className="juustify-content-start rgc-driver-info w-100 g-0">
                              <Col xs={5} md={6} className="rgc-driver-image text-end text-md-center mt-2" >

                                {data.img_Users == null ?
                                  <i className="fa fa-user-circle  rgc-avatar-icon" aria-hidden="true"></i>
                                  :
                                  <Image src={ProfileUrl + data.img_Users} className="rgc-avatar-driver" />

                                }
                              </Col>

                              <Col xs={7} md={6} className="text-end mt-2">
                                <div className="rgc-driver-btn rgc-orders-btn-edit"
                                  style={{ color: data.Color, background: data.Backcolor }} >
                                  <i class="fas fa-hourglass px-1"></i>
                                  {data.Stage_Tittle}
                                </div>
                              </Col>

                              <Col xs={6} className="rgc-driver-txt text-end text-md-center">
                                <div className="d-flex flex-column">
                                  <div>
                                    <span> نام: </span>
                                    <span>{data.Name}</span>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={6} className="rgc-driver-txt text-end">
                                <div className="d-flex flex-column">
                                  <div>
                                    <span>شماره تماس:</span>
                                    <span>{data.Mobile_User}</span>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={6} className="rgc-driver-txt text-end text-md-center">
                                <div className="d-flex flex-column">
                                  <div>
                                    <span> آدرس:</span>
                                    <span>{data.Type_Area}-{data.Address}</span>
                                  </div>
                                </div>
                              </Col>

                              <Col xs={12} md={6} className="rgc-driver-txt text-end">
                                <div className="d-flex">
                                  <span> زمان حضور:</span>
                                  <div className="rgc-day">{data.Day}</div>
                                </div>
                              </Col>

                              <Col xs={12} className="rgc-weight py-2 text-center">
                                <div className="d-flex justify-content-center rgc-contact">
                                  <a href={`tel:${data.Mobile_User}`}>
                                    <i className="fa fa-phone"></i>
                                  </a>
                                  <i class='fas fa-comments'></i>
                                  <i class="fa fa-map-marker-alt"></i>
                                </div>

                              </Col>

                              <Col xs={12} className="rgc-driver-txt text-start">
                                <div className="d-flex justify-content-end">
                                  <div className="rgc-driver-txt-items">
                                    <span>وزن کل:</span>
                                    <span>{data.Weight}</span>
                                  </div>

                                  <div>
                                    <span> مبلغ کل:</span>
                                    <span>{Intl.NumberFormat('en-US').format(data.Coint)}</span>
                                  </div>

                                </div>
                              </Col>

                            </Row>
                          </Accordion.Header>
                          <Accordion.Body >
                            <hr />
                            <Row className="justify-content-start rgc-driver-content">
                              {listOredr.map((data, index) => {
                                return (
                                  <Col xs={12} lg={6} key={index} className="gx-md-5 gy-3">
                                    <Row className="rgc-driver-item g-0">
                                      <Col xs={2} className="text-center">
                                        <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                                      </Col>

                                      <Col xs={10} className="text-end">
                                        <span>{data.Type_Trash_Tittle}</span>
                                      </Col>

                                      <Col xs={6} className="text-center">
                                        <span>{data.Sub_Weight}</span><span>{data.Type_Weight_Title}</span>
                                      </Col>

                                      <Col xs={6} className="text-center">
                                        <span>{Intl.NumberFormat('en-US').format(data.Sub_Coint)}</span><span>&nbsp;ریال </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                )
                              })}

                              <div className="w-100"></div>

                              {orderTypeId === 2 &&

                                <Row className="justify-content-center">
                                  <Col xs={6} md={4} className="text-center mt-3 m-auto">
                                    <Button className="rgc-driver-btn rgc-driver-btn-remove"
                                      onClick={() => handleShow(data.Order_Id)}
                                    >
                                      لغو سفارش
                                    </Button>
                                  </Col>
                                  <Col xs={6} md={4} className="text-center mt-3 m-auto" >
                                    <Button className="rgc-driver-btn rgc-driver-btn-edit"
                                      onClick={() => toggleHandler(data.Order_Id)}
                                    >
                                      ویرایش سفارش
                                    </Button>
                                  </Col>
                                </Row>

                              }

                            </Row>
                          </Accordion.Body>
                        </Accordion.Item>
                      )
                    })}
                </Accordion>
              </Col>

            </Row>
          </Col>
        </Row>


        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Ripples className="rgc-ripple">
              <Row
                className={radioItem === 1 ?
                  "justify-content-center  rgc-modal-time rgc-station-select"
                  : "justify-content-center  rgc-modal-time"}
              >
                <Col xs={2}>
                  <div className="radio">
                    <input
                      type="radio"
                      value={1}
                      className="rgc-checkbox mt-2 me-2"
                      checked={radioItem === "1"}
                      onChange={(e) => RadioHandlerChange(e.target.value, 'عدم حضور شهروند')}

                    />
                  </div>
                </Col>

                <Col xs={5} className="text-end rgc-day">
                  <span>عدم حضور شهروند</span>
                </Col>

              </Row>
            </Ripples>

            <Ripples className="rgc-ripple">
              <Row
                className={radioItem === 2 ?
                  "justify-content-center  rgc-modal-time rgc-station-select"
                  : "justify-content-center  rgc-modal-time"}
              >
                <Col xs={2}>
                  <div className="radio">
                    <input
                      type="radio"
                      value={2}
                      className="rgc-checkbox mt-2 me-2"
                      checked={radioItem === "2"}
                      onChange={(e) => RadioHandlerChange(e.target.value, 'دلایل دیگر')}
                    />
                  </div>
                </Col>

                <Col xs={5} className="text-end rgc-day">
                  <span>دلایل دیگر</span>
                </Col>

              </Row>
            </Ripples>

          </Modal.Body>
          <Modal.Footer className="rgc-modal-button">
          <Button onClick={() => deleteHandler(order)}>
              بله
            </Button>
            <Button onClick={handleClose}>
              خیر
            </Button>
           
          </Modal.Footer>
        </Modal>
      </Container>
      <OrderForm Status={status} order={orderId} toggle={isOpen} toggleHandler1={toggleHandler} />
    </div>
  )
}

export default Orders